module.exports = {
  messages: {
    BUTTON_SEND: 'Invia',
    CONTACT_FORM_CHOOSE_SUBJECT: 'Please choose a subcategory.',
    CONTACT_FORM_CHOOSE_TOPIC: 'Please choose a category.',
    CONTACT_FORM_CONFIRM_NEW_EMAIL_ADDRESS:
      '<strong>Please activate your e-mail address now:</strong><br/>Click the link in the activation e-mail we sent to <strong>{email}</strong>.',
    CONTACT_FORM_FILE_UPLOAD_CHOOSE_BUTTON: 'Aggiungi',
    CONTACT_FORM_FILE_UPLOAD_ERR_FILE_TOO_LARGE:
      'Purtroppo la dimensione del file <strong>{fileName}</strong> supera il massimo permesso di {maxFileSize} MB.',
    CONTACT_FORM_FILE_UPLOAD_ERR_TOO_MANY_FILES:
      'Per favore, aggiungi un massimo di {maxAmount} file.',
    CONTACT_FORM_FILE_UPLOAD_ERR_UNSUPPORTED_FORMAT:
      'Il file <strong>{fileName}</strong> non è un file JPEG, PNG o PDF.',
    CONTACT_FORM_FILE_UPLOAD_HEADLINE: 'Aggiungi immagine o file',
    CONTACT_FORM_FILE_UPLOAD_PROGRESS_SUFFIX: 'caricato ',
    CONTACT_FORM_FILE_UPLOAD_SIZE_INFO:
      'Fino a {maxAmount} file con un massimo di 10 MB per file',
    CONTACT_FORM_FILE_UPLOAD_TYPE_INFO: 'Formati: JPG, PNG e PDF',
    CONTACT_FORM_FILE_UPLOAD_UNAVAILABLE:
      'Al momento non è possibile aggiungere file. Per favore, tenta nuovamente.',
    CONTACT_FORM_OKAY:
      'Il tuo messaggio è stato inviato e ce ne occuperemo al più presto.',
    CONTACT_FORM_SERVER_ERROR: 'Something went wrong. Please try again later.',
    CONTACT_FORM_THANKS: 'Grazie!',
    CONTACT_FORM_TO_STARTPAGE: 'Continue to homepage',
    CONTACT_FORM_USER_EMAIL_INFO:
      'Please note that the response will be sent to <strong>{email}</strong>. If this e-mail address is outdated, please change it <strong><a>here</a></strong>.',
    SUPPORTHTML_ERRFORM:
      'Durante il riempimento del modulo si sono verificati uno o più errori. Correggi i campi indicati.',
    SUPPORTHTML_HELP_DESCRIPTION:
      'Qui hai la possibilità di inviarci le tue domande. Suggerimento: controlla prima se il tuo quesito può già trovare risposta su  <a>{help_link}</a> .',
    SUPPORTHTML_HELP_DESCRIPTION_ONLYFY:
      '<p> ↩︎ \nVuoi ricevere maggiori informazioni sulle nostre soluzioni di recruiting o hai bisogno di supporto per accedere al tuo account? ↩︎ \n</p> ↩︎ \n<p> ↩︎ \nIl nostro <a target="_blank" href="https://help.onlyfy.com/">Centro di assistenza</a> è a tua disposizione 24 ore su 24. Se non dovessi trovare risposta ai tuoi quesiti, inviaci una <a target="_blank" href="https://help.onlyfy.com/hc/de/requests/new">Richiesta</a>. ↩︎ \n</p>',
    SUPPORTHTML_MAIL:
      'Indirizzo e-mail (al quale possiamo inviare la nostra risposta)',
    SUPPORTHTML_SENDNAME: 'Il tuo nome e cognome',
    SUPPORTHTML_SUB0: 'Come possiamo aiutarti?',
  },
};
